import React from 'react';
import { Section, SectionHeader, Logo } from '../ui';

const features = [
  'Qualified candidate submissions',
  'Pay for success',
  'Structured recruiter competition',
  'Unified delivery workspace',
];
const traditionalData = [
  'Costly agency model',
  'Limited visibility',
  'Manual/Email coordination',
  'Relationship-driven only',
];
const boardsData = [
  'Resume flooding',
  'Pay for exposure',
  'Resume matching only',
  'No accountability',
];

// eslint-disable-next-line import/prefer-default-export
export function Comparison() {
  const subtitle = (
    <span className="text-tertiary">
      Stop compromising. Start working efficiently with recruiters.
    </span>
  );

  return (
    <Section variant="default">
      <div className="max-w-6xl mx-auto px-4">
        <SectionHeader title="How We're Different" subtitle={subtitle} subtitleTag="h3" />
        {/* Desktop */}
        <div className="hidden md:grid md:grid-cols-3 gap-6">
          <div
            aria-label="Traditional Agencies"
            className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden flex flex-col"
          >
            <div className="bg-slate-100 h-20 flex items-center justify-center border-b border-slate-200 px-5">
              <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500">
                Traditional Agencies
              </h4>
            </div>
            <ul className="divide-y divide-slate-100 grow">
              {traditionalData.map(item => (
                <li
                  key={item}
                  className="h-20 flex items-center justify-center p-5 text-center text-sm text-slate-600 font-medium"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div
            aria-label="Job Boards"
            className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden flex flex-col"
          >
            <div className="bg-slate-100 h-20 flex items-center justify-center border-b border-slate-200 px-5">
              <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500">
                Job Boards
              </h4>
            </div>
            <ul className="divide-y divide-slate-100 grow">
              {boardsData.map(item => (
                <li
                  key={item}
                  className="h-20 flex items-center justify-center p-5 text-center text-sm text-slate-600 font-medium"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div
            aria-label="BoostHiring"
            className="rounded-xl border-2 border-secondary bg-gradient-to-b from-primary/5 via-white to-secondary/5 shadow-lg shadow-secondary/20 overflow-hidden ring-1 ring-secondary/20 flex flex-col"
          >
            <div className="bg-gradient-to-r from-primary to-primary/90 h-20 flex items-center justify-center border-b border-primary/20 px-5">
              <Logo variant="white" className="!text-2xl" />
            </div>
            <ul className="divide-y divide-secondary/10 grow">
              {features.map(item => (
                <li
                  key={item}
                  className="h-20 flex items-center justify-center p-5 text-center text-sm font-bold text-primary"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* Mobile */}
        <div className="md:hidden space-y-6">
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
            <div className="bg-slate-100 h-16 flex items-center justify-center border-b border-slate-200 px-4">
              <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500">
                Traditional Agencies
              </h4>
            </div>
            <ul className="divide-y divide-slate-100">
              {traditionalData.map(item => (
                <li
                  key={item}
                  className="min-h-16 flex items-center justify-center p-4 text-center text-sm text-slate-600 font-medium"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
            <div className="bg-slate-100 h-16 flex items-center justify-center border-b border-slate-200 px-4">
              <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500">
                Job Boards
              </h4>
            </div>
            <ul className="divide-y divide-slate-100">
              {boardsData.map(item => (
                <li
                  key={item}
                  className="min-h-16 flex items-center justify-center p-4 text-center text-sm text-slate-600 font-medium"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-secondary bg-gradient-to-b from-primary/5 via-white to-secondary/5 shadow-lg shadow-secondary/20 overflow-hidden">
            <div className="bg-gradient-to-r from-primary to-primary/90 h-16 flex items-center justify-center border-b border-primary/20 px-4">
              <Logo variant="white" className="!text-2xl" />
            </div>
            <ul className="divide-y divide-secondary/10">
              {features.map(item => (
                <li
                  key={item}
                  className="min-h-16 flex items-center justify-center p-4 text-center text-sm font-bold text-primary"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
}
